import { SelectApi } from '@presentation/components/molecules'
import { SelectApiProps } from '@presentation/types/components/molecules'

const DescriptionSelectApi: React.FC<SelectApiProps> = props => {
  return <SelectApi {...props} />
}

export default DescriptionSelectApi
